// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"f092b39e","729":"1dc6dbee","758":"230ad7d4","787":"9ebb9e5b"}[chunkId] + ".chunk.js";
};